// Gatsby requirements
import React, { useEffect } from "react"
import { storyblokEditable } from "gatsby-source-storyblok";

// Styles
import * as CSS from './sectionTableOfContents.module.scss'

const SectionTableOfContents = ({ blok }) => {

        // Creates the table of contents
        useEffect(() => {
            var els = document.getElementById('content').querySelectorAll("h2, h3");
            const table = document.getElementById('table')
            for (var i = 0; i < els.length; i++) {
                const textToId = [els[i].innerText.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'')]
                els[i].setAttribute('id', textToId);
                if (els[i]?.nodeName === 'H2') {
                    const newLi = document.createElement("li");
                    const newA = document.createElement("a");
                    newA.href = '#'+textToId;
                    const newContent = document.createTextNode(els[i].innerText);
                    newA.appendChild(newContent);
                    newLi.appendChild(newA);
                    table.appendChild(newLi);
                } 
                if (els[i]?.nodeName === 'H3' && blok.disableH3 !== true) {
                    if (els[i-1]?.nodeName === 'H2') {
                        const latestLi = table?.lastChild;
                        const newOl = document.createElement("ol");
                        const newLi = document.createElement("li");
                        const newA = document.createElement("a");
                        newA.href = '#'+textToId;
                        const newContent = document.createTextNode(els[i].innerText);
                        newA.appendChild(newContent);
                        newLi.appendChild(newA);
                        newOl.appendChild(newLi);
                        latestLi.appendChild(newOl);
                    } else {
                        const lastH3 = table?.lastChild?.lastChild;
                        const newLi = document.createElement("li");
                        const newA = document.createElement("a");
                        newA.href = '#'+textToId;
                        const newContent = document.createTextNode(els[i].innerText);
                        newA.appendChild(newContent);
                        newLi.appendChild(newA);
                        lastH3?.appendChild(newLi);
                    }
                }
            };

            // Add sublist icons
            var nums = document.getElementById("table");
            var listItem = nums.getElementsByTagName("li");
            for (let item of listItem) {
                if (item.childElementCount > 1) {
                    item.classList.add("has-sublist");
                    item.onclick = function(e) {
                        e.currentTarget.classList.toggle('active');
                    }
                }
            }
        }, []);

    return (
        <section 
            className={CSS.section}
            id={blok.anchorId}
            style={{
                backgroundColor: blok.backgroundColor,
                paddingTop: blok?.removeTopMargin ? '0.5rem' : null,
                paddingBottom: blok?.removeBottomMargin ? '0.5rem' : null
            }}
            {...storyblokEditable(blok)}
        >

            <div className={`wrapper ${blok.showTitleNextToList ? '' : CSS.showTitleAboveList}`}>

                {blok.title &&
                    <p className={CSS.title}>{blok.title}</p>
                }

                <div className={CSS.table}>
                    <ol id="table" style={{width: blok.enableFullWidth === true ? 'auto' : ''}}></ol>
                </div>

            </div>

        </section>
    )
}

export default SectionTableOfContents